module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjMzNiIgdmlld0JveD0iMCAwIDUxMiAzMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBkPSJNNTAzLjE3MiAzMzUuNzI0SDguODI4QTguODI5IDguODI5IDAgMCAxIDAgMzI2Ljg5NlY5LjEwNEE4LjgyOSA4LjgyOSAwIDAgMSA4LjgyOC4yNzZoNDk0LjM0NWE4LjgyOSA4LjgyOSAwIDAgMSA4LjgyOCA4LjgyOHYzMTcuNzkyYTguODMgOC44MyAwIDAgMS04LjgyOSA4LjgyOHoiIGZpbGw9IiM3M0FGMDAiLz4KICAgIDxjaXJjbGUgZmlsbD0iI0ZGNEI1NSIgY3g9IjIyMC42ODkiIGN5PSIxNjgiIHI9IjExNC43NTgiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bd.svg
// module id = 2070
// module chunks = 79611799117203